import { NativeModules } from 'react-native'
import { BrownfieldBridgeError } from './BrownfieldBridgeError'
import { BrownfieldBridgeDeeplink, BROWNFIELD_BRIDGE_DEEPLINK_TYPE } from './deeplinkTypes'
import type { IBrownfieldBridgeNative } from './types'
import NativeBrownfieldBridge from './NativeBrownfieldBridge'

const getBrownfieldBridge = () => NativeBrownfieldBridge ?? NativeModules.BrownfieldBridge

export const isEmbeddedEnvironment = () => Boolean(getBrownfieldBridge())

export function getNativeModule(): IBrownfieldBridgeNative | null {
  const brownfieldBridge = getBrownfieldBridge()

  if (brownfieldBridge) {
    return brownfieldBridge as IBrownfieldBridgeNative
  }

  return null
}

export function getNativeModuleOrThrow(): IBrownfieldBridgeNative {
  const brownfieldBridge = getBrownfieldBridge()

  if (brownfieldBridge) {
    return brownfieldBridge as IBrownfieldBridgeNative
  }

  throw new BrownfieldBridgeError(
    'BrownfieldBridge native module not available',
    'MODULE_UNAVAILABLE'
  )
}

export function isSupportedDeeplink(value: any): value is BrownfieldBridgeDeeplink {
  if (!value || typeof value !== 'object') return false
  if (!value.requestId || typeof value.requestId !== 'string') return false

  switch (value.type) {
    case BROWNFIELD_BRIDGE_DEEPLINK_TYPE.episode:
      return typeof value.payload.episodeId === 'string'
    case BROWNFIELD_BRIDGE_DEEPLINK_TYPE.services:
    case BROWNFIELD_BRIDGE_DEEPLINK_TYPE.physicalHealth:
    case BROWNFIELD_BRIDGE_DEEPLINK_TYPE.mentalHealth:
    case BROWNFIELD_BRIDGE_DEEPLINK_TYPE.diabetesCare:
    case BROWNFIELD_BRIDGE_DEEPLINK_TYPE.respiratoryCare:
    case BROWNFIELD_BRIDGE_DEEPLINK_TYPE.quitSmoking:
    case BROWNFIELD_BRIDGE_DEEPLINK_TYPE.ePharmacy:
    case BROWNFIELD_BRIDGE_DEEPLINK_TYPE.ePharmacyTrackPrescriptionOrder:
    case BROWNFIELD_BRIDGE_DEEPLINK_TYPE.ePharmacyAddPrescription:
    case BROWNFIELD_BRIDGE_DEEPLINK_TYPE.ePharmacyManageMedications:
    case BROWNFIELD_BRIDGE_DEEPLINK_TYPE.ePharmacyChatPharmacy:
    case BROWNFIELD_BRIDGE_DEEPLINK_TYPE.ePharmacyCarePlan:
    case BROWNFIELD_BRIDGE_DEEPLINK_TYPE.ePharmacyConsultation:
    case BROWNFIELD_BRIDGE_DEEPLINK_TYPE.pushOptIn:
    case BROWNFIELD_BRIDGE_DEEPLINK_TYPE.profile:
    case BROWNFIELD_BRIDGE_DEEPLINK_TYPE.addFamilyMember:
    case BROWNFIELD_BRIDGE_DEEPLINK_TYPE.today:
    case BROWNFIELD_BRIDGE_DEEPLINK_TYPE.inbox:
    case BROWNFIELD_BRIDGE_DEEPLINK_TYPE.account:
      return true
    default:
      return false
  }
}
